import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import API from "../../../Network/API";
import { DELETE_MY_COURSE_ROUTE, MY_COURSE_FETCH_START, MY_COURSE_FETCH_SUCCESS, MY_COURSE_TOTAL_PAGE } from "../../../Reducer/myCourseSlice";
import PostLoader from '../../../assets/loader.gif';
import { useTranslation } from "react-i18next";

export default function TutorCourse() {
  const { t } = useTranslation();
  const select_course = useSelector((state) => state.myCourseReducer);
  const [isLoading, setLoading] = useState(false);
  const [loading, setLoad] = useState(false);
  const [course_id, setCourseId] = useState(0);
  const dispatch = useDispatch();
   const location = useLocation();
    const isAppRoute = location.pathname.startsWith("/app");
  
  useEffect(() => {
    setLoad(true)
    dispatch(MY_COURSE_FETCH_START())
    API.get(`/v1/oauth/teacher/mycourses`).then((response) => {
      dispatch(MY_COURSE_FETCH_SUCCESS(response.data.data))
      dispatch(MY_COURSE_TOTAL_PAGE(response.data.data.total_page))
      setLoad(false)
    }).catch((error) => {
      setLoad(false)
    });

  }, []);

  const delete_course = (id) => {
    setCourseId(id)

    if (window.confirm(t("tutorCourse.confirm_delete"))) {
      setLoading(true)
      API.delete('/v1/oauth/teacher/course/' + id + '').then((response) => {
        setLoading(false)
        dispatch(DELETE_MY_COURSE_ROUTE(id))
      }).catch((error) => {
        setLoading(false)
      });
    }

  }
  return (
    <>

      {loading ?
        <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center', height: '500px' }}>
          <img src={PostLoader} alt={t("tutorCourse.loading")} height={80} width={80} />
        </div>
        :
        <>
          <div className="dashboard-title d-flex justify-content-between align-items-center">
            <h4>{t("tutorCourse.all_courses")}</h4>
            <Link to={`/dashboard/my-course/create`} className="btn btn-dark"><i className="fa-light fa-plus-circle me-1" />{t("tutorCourse.course_create")}</Link>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="table-responsive custom-table">
                <table className="table table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th className="text-start">{t("tutorCourse.image")}</th>
                      <th className="text-start">{t("tutorCourse.course_title")}</th>
                      <th className="text-center">{t("tutorCourse.enrolled")}</th>
                      <th className="text-center">{t("tutorCourse.add_lesson")}</th>
                      <th className="text-center">{t("tutorCourse.status")}</th>
                      <th className="text-center">{t("tutorCourse.type")}</th>
                      <th className="text-center">{t("tutorCourse.action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!select_course?.loading && select_course?.courses?.length > 0 && select_course?.courses?.map((course, j) => (
                      <tr>
                        <td className="align-middle td-cover" data-label={t("tutorCourse.image")}>
                          <img
                            height={70} width={70}
                            src={course?.cover_image || '/assets/img/no_image.jpg'}
                            alt={course?.title || t("tutorCourse.default_title")}
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop if default image also fails
                              e.target.src = '/assets/img/no_image.jpg';
                            }}
                          />

                        </td>
                        <td className="align-middle" data-label={t("tutorCourse.course")}>

                          <Link to={isAppRoute ? `/app/course/${course?.slug}` : `/course/${course?.slug}`} className="course-table-img main-course-img">

                            {course.title}
                          </Link>

                        </td >
                        <td className="text-center align-middle" data-label={t("tutorCourse.enrolled")}>{course.total_enrollment}</td>
                        <td className="text-center align-middle" data-label={t("tutorCourse.add_lesson")}>
                          <Link to={`/dashboard/my-course/sections/${course.id}`} className="addLessonBtn icon-20">
                            <i className="fa-light fa-plus-circle" />
                          </Link>
                        </td>
                        <td className="text-center align-middle" data-label={t("tutorCourse.status")}>{course.active == 1 ? <span className="status-badge ok">{t("tutorCourse.published")}</span> : <span className="status-badge muted">{t("tutorCourse.unpublished")}</span>}</td>
                        <td className="text-center align-middle" data-label={t("tutorCourse.type")}>{course.course_type}</td>
                        <td className="text-center align-middle td-actions">
                          <Link to={`/dashboard/my-course/edit/${course?.id}`} title={t("tutorCourse.edit")} className="table-action-btn"><i className="fa-light fa-pen-to-square" /></Link>
                          {course_id == course?.id && isLoading ? (
                            <span
                              className="spinner-border spinner-border-sm ml-5"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <a onClick={() => delete_course(course?.id)} href="#" title={t("tutorCourse.delete")} className="table-action-btn"><i className="fa-light fa-trash-alt" /></a>
                          )}
                          <Link to={`/dashboard/my-course/view/${course?.id}`} title={t("tutorCourse.view")} className="table-action-btn ms-1"><i className="fa-light fa-eye" /></Link>

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}